<template>
    <div>
        <div class="caption" v-if="this.team">Progress of team "{{this.team.teamName}}" in the "{{this.game.gameName}}" game</div>
        <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>

        <b-table :data="gameCompletion" v-if="gameCompletion">
            <template slot-scope="props">
                <b-table-column class="centered-table-content" field="" label="Nb">
                    <div>{{ props.index + 1}}</div>
                </b-table-column>

                <b-table-column class="centered-table-content" field="activityType" label="Type">
                    <b-tag type="is-info">{{ props.row.question.activityType }}</b-tag>
                </b-table-column>

                <b-table-column class="centered-table-content" field="question" label="Question">
                    {{ props.row.question.question }}
                </b-table-column>

                <b-table-column class="centered-table-content" field="" label="Unlocked">
                    <div align="center">
                        <b-tag type="is-success" v-if="props.row.answerFormatted.unlocked">unlocked</b-tag>
                    </div>
                </b-table-column>
                <b-table-column class="centered-table-content" field="" label="Failed attempts">
                    <div align="center">
                        <b-tag type="is-info" v-if="props.row.answerFormatted.failedAttempts">{{ props.row.answerFormatted.failedAttempts }} attemp(s)</b-tag>
                    </div>
                </b-table-column>
                <b-table-column class="centered-table-content" field="" label="Completion">
                    <div align="center">
                        <b-tag type="is-danger" v-if="props.row.answerFormatted.failed">failed</b-tag>
                        <b-tag type="is-success" v-if="props.row.answerFormatted.success">success: {{props.row.answerFormatted.score}} pts</b-tag>
                    </div>
                </b-table-column>
                <b-table-column class="centered-table-content" field="" label="Last action">
                    <span class="date" v-if="props.row.answerFormatted.unlocked">{{ formatDateAndTime(props.row.answerFormatted.dateLastModified) }}</span>
                </b-table-column>
            </template>
        </b-table>
        <div style="margin-top: 20px" >
            <button class="button is-light btn-margin" @click.prevent="cancel()">
                Back to team list
            </button>
            <button @click.prevent="refresh()" class="button is-primary" style="margin-left: 5px;">
                Refresh Progress
            </button>
        </div>
    </div>
</template>

<script>
  import teamsService from '../../services/teamsService'
  import gamesService from '../../services/gamesService'
  import displayHelper from '../../helpers/display-helper'
  const moment = require('moment')

  export default {
    data() {
      return {
        gameId: null,
        game: null,
        team: null,
        teamId: null,
        gameCompletion: null,

        isLoading: false
      }
    },
    async created() {
      try {
        if (this.$route.params.id) {
          this.gameId = this.$route.params.id
          this.game = await gamesService.getGameById(this.gameId)

          if (this.$route.params.idTeam) {
            this.teamId = this.$route.params.idTeam
            this.loadTeamById(this.gameId, this.teamId)
          }

          this.loadGameCompletionForTeam(this.gameId, this.teamId)

        } else {
          displayHelper.displayError(this, 'Oops, there was an error, gameId was not provided in the url')
        }
      } catch (err) {
        displayHelper.displayError(this, 'Oops, there was an error: ' + err.message)
      }
    },
    methods: {
      formatDateAndTime(dateStr) {
        return moment(dateStr).format('DD/MM/YYYY HH:mm').toString()
      },
      async loadGameCompletionForTeam() {
        const parent = this
        this.isLoading = true
        gamesService.getGameCompletionForTeam(this.gameId, this.teamId).then((data) => {
          this.gameCompletion = data.gameCompletionAsList
          console.log(this.gameCompletion)
        },
              (err) => {
                displayHelper.displayError(parent, 'Error while displaying the gameCompletion: ' + err.message)
              })
              .finally(() => {
                this.isLoading = false
              })
      },
      cancel() {
        this.$router.go(-1)
      },
      refresh() {
        this.loadGameCompletionForTeam()
      },
      loadTeamById(gameId, teamId) {
        this.isLoading = true
        let parent = this
        teamsService.getTeamById(gameId, teamId)
          .then((team) => {
            this.team = team
            this.isLoading = false
          })
          .catch((err) => {
            displayHelper.displayError(parent, 'Oops, there was an error: ' + err.message)
            this.isLoading = false
          })
      },
    }
  }
</script>

<style scoped>
    .caption {
        font-weight: bold;
        font-size: 1.2em;
        margin-bottom: 25px;
    }
</style>
